import React, { useState } from "react";
import "./styles.scss";

export default ({ onFilterClick, user, customFilters = null }) => {
  const [active, setActive] = useState(1);

  const default_filters = user 
  ?
    user.user_type === "fan" ? [
      { id: 1, text: "all" },
      { id: 2, key: "attachment_type", text: "audio", value: "SoundTrack" },
      { id: 3, key: "attachment_type", text: "videos", value: "Video" },
      { id: 4, key: "attachment_type", text: "pictures", value: "Image" },
      { id: 6, key: "liked_by", text: "liked", value: user.id },
      { id: 5, key: "attachment_type", text: "reposted", value: "Post" },
      { id: 7, key: "commented_by", text: "commented", value: user.id },
    ]
   : (
      user.user_type === "podcaster" ? 
        [
          { id: 1, text: "all" },
          { id: 2, key: "attachment_type", text: "videos", value: "Video" },
          { id: 3, key: "attachment_type", text: "pictures", value: "Image" },
          { id: 4, key: "liked_by", text: "liked", value: user.id },
          { id: 5, key: "attachment_type", text: "reposted", value: "Post" },
          { id: 6, key: "commented_by", text: "commented", value: user.id },
        ] 
      : [
        { id: 1, text: "all" },
        { id: 4, key: "attachment_type", text: "singles", value: "SoundTrack" },
        { id: 2, key: "attachment_type", text: "albums", value: "Album" },
        { id: 3, key: "attachment_type", text: "videos", value: "Video" },
        { id: 5, key: "attachment_type", text: "pictures", value: "Image" },
        { id: 6, key: "liked_by", text: "liked", value: user.id },
        { id: 7, key: "attachment_type", text: "reposted", value: "Post" },
        { id: 8, key: "commented_by", text: "commented", value: user.id },
      ]
    )
  : [];
  
  const filters = !!customFilters ? customFilters : default_filters;

  const clickHandler = (item) => {
    setActive(item.id);
    if (item.text === "all") {
      onFilterClick();
    } else {
      onFilterClick({ [item.key]: item.value });
    }
  };
  return (
    <div className="activity-filters overflow-hidden pl-md-3">
      <div className="d-flex overflow-x-scroll justify-content-start">
        {filters.map((item) => (
          <div
            key={item.id}
            className={`btn btn-sm mr-3 my-3 text-center ${
              item.id === active ? "active" : ""
            }`}
            onClick={() => clickHandler(item)}
          >
            <p className="text text-uppercase">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
